import { useQuery } from '@tanstack/react-query';

import { billingInfoRepo } from '@ctct/domain-layer';

import { QueryKeys } from './constants';
import { useQueryMemoized } from '../helpers/useQueryMemoized';

export const usePartner = () => {
  const query = useQuery({
    queryKey: [QueryKeys.PARTNER],
    queryFn: () => billingInfoRepo.getPartner(),
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });

  return useQueryMemoized(query);
};

export type UsePartner = ReturnType<typeof usePartner>;
